import { render } from "./DeviceInfoTabView.vue?vue&type=template&id=bdc4d818"
import script from "./DeviceInfoTabView.vue?vue&type=script&lang=js"
export * from "./DeviceInfoTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__